import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { Project } from 'types/project';
import { Chat } from 'types/chat';
import { chatApi } from './chat-api';
import { groupingChats } from 'lib/utils/common/groupingChats';

const selectChatsResult = chatApi.endpoints.getChats.select();

export const selectChats = createSelector(
  [selectChatsResult],
  (result) => result.data ?? [],
);

export const selectGroupedChats = createSelector(
  [selectChatsResult],
  (result) => {
    const chats = result.data ?? [];
    return groupingChats(chats);
  },
);

export const selectChat = (chatId: Chat['id']) =>
  createSelector([selectChatsResult], (result) =>
    result?.data?.find((chat) => chat.id === chatId),
  );

export const selectChatByProjectId = createSelector(
  [
    selectChatsResult,
    (_state: RootState, projectId: Project['id'] | undefined) => projectId,
  ],
  (chatsResult, projectId) => {
    if (chatsResult.data === undefined || projectId === undefined) return [];

    return (
      chatsResult.data.filter((chat) => chat.projectId === projectId) || []
    );
  },
);
